module.exports = __webpack_public_path__ + "img/fi-rr-grid-alt.9775ea42.svg";